import { ActionConfig } from "@Actions/action";
import { Actions, AppContext } from "@Context/common/general/context";
import initialState from "@Context/common/general/initial-state";
import { useContext } from "react";

function useGlobalContext() : {
    globalState : typeof initialState,
    dispatch : (config: ActionConfig) => Promise<void>
    updateGlobalState : (newState: any) => void
} {
    const {state, dispatch} = useContext(AppContext);

    const updateGlobalState = (newState: any) => {
        dispatch({type: Actions.CoreActions.UpdateState, payload: newState});
    }

    return { globalState: state, dispatch, updateGlobalState };
}

export default useGlobalContext;
